
export const access_info = 'Microsoft Access is a desktop database application that allows you to create and manage relational databases, design user-friendly forms, and generate reports based on your data.'

export const access_md = `
# Microsoft Access  
*Last updated on July 15, 2025*

## Overview

Microsoft Access is a desktop database application included in the Microsoft 365 suite.
It allows you to create and manage relational databases, design user-friendly forms, and generate reports based on your data.

We currently use Access to log label print jobs.

## Benefits
- **Database Creation**: Build custom databases with tables, queries, forms, and reports.
- **Minimal Coding**: Use wizards and visual tools to build database applications.
- **Integration**: Easily import/export data to and from Excel, SharePoint, and SQL Server.
- **Automation**: Use macros and VBA to automate repetitive tasks and streamline workflows.

## Requirements
- A user account with us
- A valid Microsoft 365 subscription
- Access is only available on PC

## Getting Started
- Access is included with certain Microsoft 365 desktop installations. If it's not already installed, you can install it from the [Microsoft 365](https://it.bockwaterheaters.com/#/services/m365) portal.

## Support
- Contact our [IT Help Desk](https://it.bockwaterheaters.com/#/help)

`